import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { retrieveLogoLocation } from "../../services/UserLogoService";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

/**
 * Custom hook to load user data based on the provided authentication token.
 * @param {Object} params - The parameters for the hook.
 * @param {string} params.token - The authentication token used to fetch user data.
 * @return {Object} An object containing the user data.
 * @throws {Error} Throws an error if the user data cannot be loaded.
 */
export const useUserLoader = ({ token, userId }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !userId) return;
    const perform = async () => {
      try {
        const url = `${BASE_URL}user-collection/${userId}`;
        const res = await fetch(url, { headers: { Authorization: token } });
        if (res.ok) {
          let u = await res.json();
          u = await loadLogo(u);
          setUser(u);
        } else navigate("/entrar?refresh=true");
      } catch (err) {
        console.error("Error loading user" + err);
        navigate("/entrar?refresh=true");
      }
    };

    const loadLogo = async (u) => {
      try {
        const urlTmp = await retrieveLogoLocation(u.email, token);
        if (urlTmp) u.brand.logoURLTmp = urlTmp;
        return u;
      } catch (err) {
        console.error("Error retrieving logo location:", err);
        return u; // Return user data even if logo retrieval fails
      }
    };
    perform();
  }, [token, userId]);

  return { user, setUser };
};
